export const SITE = {
  name: "Kernected Disability Support Services",
  shortName: "Kernected Disability",
  tagline: "NDIS Support Coordination, made simple.",
  email: "KERNECTEDDISABILITYSUPPORT@proton.me",
  phonePlaceholder: "Available by request",
  region: "Australia",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_ndis-support-hub-4/artifacts/3r31q55x_kernected%20logo%202.png",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact", to: "/contact" },
];
